import { Route, Routes, Navigate } from 'react-router-dom';
import { PredictionsPage } from './pages';
import { PositionsPage } from './pages/PositionsPage';
import { CostsPage } from './pages/CostsPage';
import { UnwindingPage } from './pages/UnwindingPage';
import { PredictionMapperPage } from 'src/Modules/PredictionMapper';
import { PredictionsStatus } from 'src/Modules/Arbitrage/pages/PredictionsStatus';
import { PredictionsProviders } from './Providers';
import { PositionsProvider } from './context';

export const PredictionsRouter = () => {
  return (
    <Routes>
      <Route
        path="opportunities"
        element={
          <PredictionsProviders>
            <PredictionsPage />
          </PredictionsProviders>
        }
      />
      <Route
        path="positions"
        element={
          <PositionsProvider>
            <PositionsPage />
          </PositionsProvider>
        }
      />
      <Route path="costs" element={<CostsPage />} />
      <Route path="unwinding" element={<UnwindingPage />} />
      <Route path="mapper" element={<PredictionMapperPage />} />
      <Route path="status" element={<PredictionsStatus />} />
      <Route path="*" element={<Navigate replace to="opportunities" />} />
    </Routes>
  );
};
